import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { encodeQuery } from 'Helpers/Query';
import fr from 'facet-rest';
import { PrimaryActionButton } from '@facet-wealth/design';
import { clientPaths } from 'Consts/Strings';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { dataAttrs } from 'Helpers/Testing';

const useStyles = buildUseStyles('ViewScenarioButton', () => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ViewScenarioButton = ({
  resource,
}) => {
  const classes = useStyles();
  const history = useHistory();

  const handleClick = () => {
    const viewScenarioLink = `${clientPaths.scenarios}${encodeQuery({ pageSelfLink: resource.relationship(fr.relationships.facetPlanClientView.name)?.link('related').url() })}`;
    history.push(viewScenarioLink);
  };

  return (
    <div className={classes.root}>
      <PrimaryActionButton
        label="View current roadmap"
        onClick={handleClick}
        {...dataAttrs('view-current-roadmap')}
      />
    </div>
  );
};

ViewScenarioButton.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ViewScenarioButton;
